// TS twin of iOS WheelDetectionKit `CurrentWheelSize` (0.7.0, ?use_ios_ui).
//
// The size of the wheel ALREADY on the shopper's car — one answer for the
// whole scene, asked on the front-door card and kept on the panel's MASK
// tile. Not the size of the wheel being placed: the difference between the
// two is what sets the band covering the real wheel.

/** Everything the assembler ships, with room either side. */
export const CURRENT_WHEEL_SIZE_RANGE = { min: 13, max: 30 } as const

/** Riley's placement allowance, in DIAMETER inches: the virtual wheel is
 *  never perfectly centred on the real one, so even a wheel placed at its
 *  own size needs a thin ring to cover the sliver that shows. */
export const CURRENT_WHEEL_SIZE_BUFFER_IN = 1

/** Inches of diameter to metres of radial band — 0.0254 / 2. The halving
 *  lives here and nowhere else: sizes are quoted as diameters, the ring is
 *  built as a radial width. */
export const INCHES_TO_RADIAL_METRES = 0.0127

export interface TCurrentWheelSize {
  /** Diameter in inches, as the owner would say it. Clamped to the range. */
  readonly inches: number
}

export function currentWheelSize(inches: number): TCurrentWheelSize {
  return {
    inches: Math.min(Math.max(inches, CURRENT_WHEEL_SIZE_RANGE.min), CURRENT_WHEEL_SIZE_RANGE.max),
  }
}

/**
 * Radial width of the ring needed to cover the real wheel behind a virtual
 * wheel of `selectedInches`.
 *
 * A wheel at least as large as the real one hides it without help, so it
 * gets no ring at all — the buffer does not survive going up a size, half
 * an inch included. The 1.5" edge-to-edge allowance is absent on purpose:
 * it applies to both wheels and cancels out of the subtraction.
 */
export function bandMetres(current: TCurrentWheelSize, selectedInches: number): number {
  if (current.inches < selectedInches) return 0
  return (current.inches - selectedInches + CURRENT_WHEEL_SIZE_BUFFER_IN) * INCHES_TO_RADIAL_METRES
}
